var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c(
            "div",
            { staticClass: "submission-header" },
            [
              _c(
                "el-form",
                { staticClass: "from-s", attrs: { inline: true } },
                [
                  _c("div", { staticClass: "flex-row flex-col" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "submission-tab" },
                        [
                          _c(
                            "el-tabs",
                            {
                              on: { "tab-click": _vm.handleExamine },
                              model: {
                                value: _vm.examineActive,
                                callback: function ($$v) {
                                  _vm.examineActive = $$v
                                },
                                expression: "examineActive",
                              },
                            },
                            _vm._l(_vm.examineTabData, function (item, index) {
                              return _c("el-tab-pane", {
                                key: item.id,
                                attrs: {
                                  label: item.name,
                                  name: item.id,
                                  lazy: "",
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "splitLine" }),
          _vm._v(" "),
          _c("examine", {
            ref: "examine",
            attrs: { examineActive: _vm.examineActive },
            on: { "get-content-value": _vm.getContentValue },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }